<template>
  <div class="aside-order-progress">
    <ol>
      <li :class="{current: step === 1}">Paiement</li>
      <li :class="{current: step === 2}">Accessoires</li>
      <li :class="{current: step === 3}">Services</li>
      <li :class="{current: step === 4}">Panier</li>
    </ol>
    <progress v-if="!isSafari" :max="100" :value="progress"></progress>
    <div v-if="isSafari" :style="`width:${progress}%`" style="height: 5px; border-radius: 5px; background-color: var(--dark-blue); margin-top: .5rem;margin-bottom: 2rem" />
  </div>
</template>

<script>
export default {
  name: 'OrderFunnelProgressSteps',
  props: {
    step: {
      type: Number,
      default: 1,
    },
    totalSteps: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      progress: 0,
    }
  },
  computed: {
      isSafari() {
        const userAgent = navigator.userAgent;
        if (window.chrome) return false; // for IOS
        return userAgent.includes('Safari') && !userAgent.includes('Chrome');
      },
    gridMatch() {
        return {
          1: 1.05,
          2: 2.2,
          3: 3.15,
          4: 4,
        }
    },
  },
  watch: {
    step(newVal, oldVal) {
      // console.log('step changed from ' + oldVal + ' to ' + newVal)
      this.smoothTransition((this.gridMatch[oldVal] / this.totalSteps * 100), (this.gridMatch[newVal] / this.totalSteps * 100), 500)
    },
  },
  methods: {
    smoothTransition(startValue, endValue, duration) {
      let startTime;
      const easing = t => t * (2 - t); // You can use different easing functions

      const vm = this
      function update(currentTime) {
        if (!startTime) startTime = currentTime;
        const elapsedTime = currentTime - startTime;
        if (elapsedTime >= duration) {
          // Reached the end value
          // console.log(`End value: ${endValue}`);
          vm.progress = endValue
        } else {
          // Calculate the intermediate value based on easing function
          const progress = elapsedTime / duration;
          const interpolatedValue = startValue + (endValue - startValue) * easing(progress);
          // console.log(`Current value: ${interpolatedValue}`);
          vm.progress = interpolatedValue
          // Request the next animation frame
          requestAnimationFrame(update);
        }
      }
      // Start the animation
      requestAnimationFrame(update);
    },
  },
  beforeMount() {
    this.progress = this.step / this.totalSteps * 100
  },
}
</script>

<style scoped lang="scss">
.aside-order-progress {
  margin-bottom: 1rem;

  ol {
    display: grid;
    grid-template-columns: 1.1fr 1.2fr 1fr .9fr;
    list-style: inside;
    grid-gap: .5rem;
    font-family: var(--g2r-headings-font);
    @media screen and (min-width: 768px) {
      font-size: larger;
    }

    li {
      list-style-type: disclosure-closed;
      opacity: .8;
      &.current {
        opacity: 1;
        //text-decoration: underline;
      }
    }
  }

  progress {
    width: 100%;
    height: 20px;
    //height: 8px;
    ////accent-color: var(--yellow);
    ////background-color: whitesmoke;
    //-webkit-appearance: none;
    //appearance: none;
    //$radius: 30px;
    //&::-webkit-progress-bar {
    //  background-color: whitesmoke;
    //  border-radius: $radius;
    //}
    //&::-webkit-progress-value {
    //  background-color: var(--yellow);
    //  border-bottom-left-radius: $radius;
    //  border-top-left-radius: $radius;
    //}
  }
}

</style>
